import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Nav,
  NavItem,
  UncontrolledTooltip,
  Button,
} from 'reactstrap';
import $ from 'jquery';
import { injectIntl } from 'react-intl';

import { showModal } from '../actions';
import { canDownloadPageItem } from '../helpers/PageSections';

import {
  hideIntercomWidget,
  showIntercomWidget,
} from '../helpers';
import {
  PageIdContext,
} from '../helpers/PageIdContext';

const ActionbarPageActions = ({
  intl,
  share,
  filesTotal,
  selectedFiles,
  selectedAllFiles,
  collectionsTotal,
  selectedCollections,
  selectedAllCollections,
  reorderingMode,
  handleDownload,
}) => {
  const { pageId, collection, collectionFileUuids = [] } = useContext(PageIdContext);

  useEffect(() => {
    const moreElements = $('.actionbar .action-more .dropdown-menu button').length;
    if (moreElements > 0) {
      $('.actionbar .action-more').removeClass('hidden');
    } else {
      $('.actionbar .action-more').addClass('hidden');
    }

    if (!share) {
      return;
    }

    if (selectedCollections.length === 0 && selectedFiles.length === 0) {
      showIntercomWidget();
    } else {
      hideIntercomWidget();
    }
  });

  if (reorderingMode) {
    return null;
  }

  const lockSelectedAllFilesAction = (
    (selectedAllFiles && selectedFiles.length !== filesTotal) ||
    (selectedAllCollections && selectedCollections.length !== collectionsTotal)
  );

  const downloadableFiles = selectedFiles.filter(file => (
    collectionFileUuids.includes(file.uuid)
      ? canDownloadPageItem(collection)
      : canDownloadPageItem(file)
  ));
  const downloadableCollections = selectedCollections.filter(canDownloadPageItem);
  const fileCollectionMap = {};
  downloadableFiles.forEach((file) => {
    const collectionUuid = collection?.uuid && collectionFileUuids.includes(file.uuid)
      ? collection.uuid
      : file.pageCollectionUuid;
    if (collectionUuid) {
      fileCollectionMap[file.uuid] = [collectionUuid];
    }
  });
  const showDownloadButton = downloadableFiles.length > 0 || downloadableCollections.length > 0;

  return (
    <Nav className="ml-auto" navbar>
      {showDownloadButton && (
        <NavItem>
          <Button
            id="ABPageDownload"
            href="#download"
            className="actionbar-action-button"
            onClick={(e) => {
              e.preventDefault();
              handleDownload(downloadableCollections, downloadableFiles, pageId, fileCollectionMap);
            }}
            disabled={lockSelectedAllFilesAction}
          >
            <i className="far fa-download" />
            {intl.formatMessage({ defaultMessage: 'Download' })}
          </Button>
          {lockSelectedAllFilesAction && (
            <UncontrolledTooltip fade={false} placement="top" target="ABPageDownload">
              {intl.formatMessage({ defaultMessage: 'Load all files to download' })}
            </UncontrolledTooltip>
          )}
        </NavItem>
      )}
    </Nav>
  );
};

const mapStateToProps = (state, props) => ({
  profile: state.Auth.profile,
  share: state.Shares.share,
  files: state.Files.files,
  filesTotal: props.filesTotal ?? state.Files.filesTotal,
  selectedFiles: state.Files.selectedFiles,
  selectedAllFiles: state.Files.selectedAllFiles,
  collectionsTotal: props.collectionsTotal ?? state.Collections.collectionsTotal,
  selectedCollections: state.Collections.selectedCollections,
  selectedAllCollections: state.Collections.selectedAllCollections,
  collection: state.Collections.collection,
  sidebarCollection: state.Collections.sidebarCollection,
  reorderingMode: state.Files.reorderingMode,
  collectionMoveModal: state.Collections.moveModalOpen,
});

const mapDispatchToProps = dispatch => ({
  handleDownload: (collections, files, pageId, fileCollectionMap) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      files,
      collections,
      fileCollectionMap,
      pageId,
      backdrop: true,
    }));
  },
});

ActionbarPageActions.propTypes = {
  intl: PropTypes.object.isRequired,
  share: PropTypes.object,
  filesTotal: PropTypes.number.isRequired,
  collectionsTotal: PropTypes.number.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  selectedAllFiles: PropTypes.bool.isRequired,
  selectedCollections: PropTypes.array.isRequired,
  selectedAllCollections: PropTypes.bool.isRequired,
  handleDownload: PropTypes.func.isRequired,
  reorderingMode: PropTypes.bool.isRequired,
};

ActionbarPageActions.defaultProps = {
  share: null,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ActionbarPageActions));
